import PropTypes from 'prop-types';
import React from 'react';
import SearchBar from '@bibliocommons/search-bar';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import { Tabs, TabContent } from '@bibliocommons/deprecated-base-tabs';

import '../styles/AddTitle.scss';

class AddTitle extends React.PureComponent {
  componentDidUpdate() {
    if (this.props.onUpdateHandle) {
      this.props.onUpdateHandle();
    }
  }

  renderTabContent(options, id, eventkey) {
    if (options === undefined) {
      return null;
    }

    const { handleSearch, handleClear, handleQueryChange, renderResults, searchLabel, tabName, query } = options;

    return (
      <TabContent eventKey={eventkey} key={id} tabHref={id} label={tabName} testId={`add-${id}`}>
        <SearchBar
          query={query}
          label={searchLabel}
          handleSearch={handleSearch}
          handleClear={handleClear}
          handleChange={handleQueryChange}
          isWrappedInForm={this.props.isWrappedInForm === undefined ? true : this.props.isWrappedInForm}
        />
        {this.renderProgressBar()}
        {renderResults()}
      </TabContent>
    );
  }

  renderProgressBar() {
    return (
      <div className="progress-bar-wrapper">
        <ProgressBar active={this.props.searching} />
      </div>
    );
  }

  render() {
    const { catalogueOptions, webOptions } = this.props;
    return (
      <section className="cp-add-title">
        <Tabs defaultActiveKey={0}>
          {this.renderTabContent(catalogueOptions, 'catalog-item-tab', 0)}
          {this.renderTabContent(webOptions, 'web-item-tab', 1)}
        </Tabs>
      </section>
    );
  }
}

const tabOptionsShape = PropTypes.shape({
  tabName: PropTypes.string.isRequired,
  searchLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  handleSearch: PropTypes.func.isRequired,
  handleClear: PropTypes.func,
  handleQueryChange: PropTypes.func,
  renderResults: PropTypes.func
});

AddTitle.propTypes = {
  catalogueOptions: tabOptionsShape,
  webOptions: tabOptionsShape,
  searching: PropTypes.bool,
  onUpdateHandle: PropTypes.func,
  isWrappedInForm: PropTypes.bool
};

export default AddTitle;
